<template>
  <v-container fluid id="settlement-corrections">
    <v-row dense>
      <v-col cols="12">
        <DataTable
          :items="corrections"
          :headers="headers"
          :selected.sync="selectedItemsModel"
          :customCells="customCells"
          :showSelect="showSelect"
          tableKey="ticketCorrectionId"
          :showSearch="showSearch"
          :showDense="showDense"
          :allSelected="allSelected"
          @select-all-clicked="selectAllClicked"
          hideDefaultSelectAll
          :tableHeightCalculationData="{ auto: true }"
          @search-changed="searchChanged"
        >
          <template #actions="{item}">
            <Icon
            icon="mdi-information-outline"
            margin="mr-1"
            dataTestId="correction-detail-button"
            :small="false"
            :tooltipText="$t('correctionDetails')"
            @icon-clicked="viewDetailedCorrection(item)"/>
          </template>

          <template #header.data-table-select>
            <Icon
            top
            :icon="iconForSelectAllBox"
            :iconColor="allSelected ? 'success' : 'rgba(0,0,0,0.3)'"
            :tooltipText="selectAllTooltipText"
            tooltipColor="secondary"
            :small="false"
            @icon-clicked="selectAllClicked"
            :disabled="selectAllDisabled"
            :style="selectAllStyle"
            />
          </template>

          <template #footer v-if="showSelect">
            <v-container fluid>
              <v-chip :color="allSelected ? 'success' : ''">
                <span>
                  {{ `${$t('selected')}: ${selectedItemsModel.length} / ${(corrections).length}` }}
                </span>
              </v-chip>
            </v-container>
            <v-col class="pt-4" v-if="showSelect">
              <span class="grey--text">{{'*' + $t(contractMode.value === ContractMode.Logs.value ? 'tractAccountDestinationSettingMayBeResultOfCorrections' : 'accountDestinationMayBeResultOfCorrections')}}</span>
            </v-col>
          </template>
        </DataTable>
      </v-col>
  </v-row>
    <DetailedCorrectionDialog
    v-if="correctionDetailDialog"
    :ticketId="focusedCorrection.ticketId"
    :correctionId="focusedCorrection.ticketCorrectionId"
    @close="closeCorrectionDetail"
    :contractMode="contractMode"
    />
  </v-container>
</template>

<script>
import { ticketCorrectionHeaders } from '@/headers/ExportBatch.js'
import { ContractMode } from '@/utils/Enumerations.js'
import IconHelpers from '@/utils/IconHelpers'
import { isEqual, intersection } from 'lodash'

export default {
  name: 'SettlementCorrections',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    DetailedCorrectionDialog: () => import('@/components/ticket/corrections/DetailedCorrectionDialog.vue')
  },

  props: {
    corrections: {
      type: Array,
      default: () => []
    },
    selectedItems: {
      type: Array,
      required: false
    },
    showSelect: {
      type: Boolean,
      required: false
    },
    contractMode: {
      type: Object,
      required: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showDense: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    ContractMode,
    IconHelpers,
    correctionDetailDialog: false,
    focusedCorrection: undefined,
    search: null
  }),

  computed: {
    selectedItemsModel: {
      get () { return this.selectedItems },
      set (value) {
        this.$emit('update:selectedItems', value)
      }
    },
    headers () {
      return this.contractMode.value === this.ContractMode.Logs.value
        ? ticketCorrectionHeaders().filter(i => i.value !== 'fromAccount')
        : ticketCorrectionHeaders().filter(i => i.value !== 'tract' && i.value !== 'setting')
    },

    customCells () {
      return [
        {
          slotName: 'actions',
          value: 'actions'
        }
      ]
    },

    allSelected () {
      if (!this.showSelect) return false
      const items = this.corrections
      const itemIds = items.map(i => i.ticketCorrectionId).toSorted()
      const selected = this.selectedItemsModel.map(i => i.ticketCorrectionId).toSorted()

      return isEqual(itemIds, selected)
    },

    iconForSelectAllBox () {
      return this.allSelected ? 'mdi-checkbox-multiple-marked'
        : this.allFilteredSelected ? 'mdi-checkbox-multiple-marked-outline'
          : this.selectedItemsModel.length > 0 ? 'mdi-minus-box-multiple'
            : 'mdi-checkbox-multiple-blank-outline'
    },

    selectAllTooltipText () {
      const viewingFiltered = this.selectedFilter
      if (viewingFiltered) {
        return this.allFilteredSelected || this.allSelected
          ? this.$t('deselectAllFiltered')
          : this.$t('selectAllFiltered')
      } else {
        return this.allSelected
          ? this.$t('deselectAll')
          : this.$t('selectAll')
      }
    },

    selectAllDisabled () {
      return !!this.search
    },

    selectAllStyle () {
      return this.selectAllDisabled ? 'pointer-events: none; opacity: 0.25;' : ''
    }
  },

  methods: {
    intersection,
    async viewDetailedCorrection (correction) {
      this.focusedCorrection = correction
      this.correctionDetailDialog = true
    },

    closeCorrectionDetail () {
      this.focusedCorrection = undefined
      this.correctionDetailDialog = false
    },

    selectAllClicked () {
      if (this.allSelected) {
        this.selectedItemsModel = []
      } else {
        this.selectedItemsModel = (this.corrections)
      }
    },

    searchChanged (search) {
      this.search = search
    }
  }
}
</script>
